<template>
  <div class="region">

    <header-bar process="signup"></header-bar>


    <section class="instructions background-image">
      <div class="grid-container">
        <div class="col-4">
          <h2>Which area(s) of Africa do you want to make change happen in?</h2>
          <input placeholder="Search for a country..." class="search" type="text" v-model="queryText">
        </div>
      </div>
    </section>
    
    <section class="item-selection">
      <div class="grid-container">
      
        <div v-if="CentralCountries.length">
          <h3 @click="toggleGroup('showCen')" :class="{'active': showCen}">Central Africa</h3>
          <div class="toggle" v-show="showCen">
            <div class="row" v-for="row in CentralCountries">
              <picker-item v-for="item, key in row" itemclass="countries" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
              </picker-item>
            </div>
          </div>
        </div>

        <div v-if="NorthCountries.length">
          <h3 @click="toggleGroup('showNor')" :class="{'active': showNor}">North Africa</h3>
          <div class="toggle" v-show="showNor">
            <div class="row" v-for="row in NorthCountries">
              <picker-item v-for="item, key in row" itemclass="countries" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
              </picker-item>
            </div>
          </div>
        </div>

        <div v-if="EastCountries.length">
          <h3 @click="toggleGroup('showEas')" :class="{'active': showEas}">East Africa</h3>
          <div class="toggle" v-show="showEas">
            <div class="row" v-for="row in EastCountries">
              <picker-item v-for="item, key in row" itemclass="countries" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
              </picker-item>
            </div>
          </div>
        </div>

        <div v-if="SouthCountries.length">
          <h3 @click="toggleGroup('showSou')" :class="{'active': showSou}">South Africa</h3>
          <div class="toggle" v-show="showSou">
            <div class="row" v-for="row in SouthCountries">
              <picker-item v-for="item, key in row" itemclass="countries" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
              </picker-item>
            </div>
          </div>
        </div>

        <div v-if="WestCountries.length">
          <h3 @click="toggleGroup('showWes')" :class="{'active': showWes}">West Africa</h3>
          <div class="toggle" v-show="showWes">
            <div class="row" v-for="row in WestCountries">
              <picker-item v-for="item, key in row" itemclass="countries" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
              </picker-item>
            </div>
          </div>
        </div>

      </div>
    </section>

    <section class="sign-up-navigation">
      <div class="grid-container">
        <a href="#" v-on:click.stop.prevent="stepBack" class="link-back">Change focus area</a>
        <a href="#" v-on:click.stop.prevent="progress" class="btn btn-big bg-four active">Next</a>
        <p class="tip" v-if="showTip">(Optional) You can choose as many regions as you like.</p>

        <div class="item-added-holder">

          <slider :data="selectedItemTags" :items="noOfItems"></slider>

        </div>
      </div>
    </section>


  </div>
</template>

<script>
import { db } from '@/firebase'

import HeaderBar from '@/components/HeaderBar'
import PickerItem from '@/components/register/PickerItem'
import Slider from '@/components/register/Slider'

export default {
  data () {
    return {
      selectedItems: [],
      selectedItemTags: [],
      queryText: '',
      noOfItems: null,
      countries: [],
      showCen: true,
      showNor: false,
      showEas: false,
      showSou: false,
      showWes: false
    }
  },
  components: {
    HeaderBar,
    PickerItem,
    Slider
  },
  methods: {
    stepBack () {
      this.$parent.currentStep--
    },
    chunkMethod: function (items) {
      let chunks = []
      let arr = items
      let i
      let chunkSize = 6

      for (i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize))
      }
      return chunks
    },
    toggleGroup: function (dataId) {
      if (this[dataId] === true) {
        this[dataId] = false
      } else {
        this.showCen = false
        this.showNor = false
        this.showEas = false
        this.showSou = false
        this.showWes = false
        this[dataId] = true
      }
    },
    progress () {
      let itemData = {}

      for (var i = 0; i < this.selectedItems.length; ++i) {
        itemData[this.selectedItems[i]] = true
      }
      console.log(itemData)

      let user = this.$root.user.uid
      let parent = this
      db.ref('users-registration/' + user + '/personality/countries').set(itemData, function () {
        // On complete
        console.log('saved')
        parent.$parent.currentStep++
      })
    },
    removeTag (id, name) {
      this.selectedItems.splice(this.selectedItems.indexOf(id), 1)
      this.selectedItemTags.splice(this.selectedItemTags.indexOf(name), 1)
    }
  },
  computed: {
    CentralCountries: function () {
      if (this.countries) {
        let arr = this.countries.filter(function (el) {
          return el.region === 'Central'
        })
        if (!this.queryText) {
          let index = arr.map(function (o) { return o['.key'] }).indexOf('whole-Central')
          let front = arr.splice(index, 1)
          arr.unshift(front[0])
        }
        return this.chunkMethod(arr)
      }
    },
    NorthCountries: function () {
      if (this.countries) {
        let arr = this.countries.filter(function (el) {
          return el.region === 'North'
        })
        if (!this.queryText) {
          let index = arr.map(function (o) { return o['.key'] }).indexOf('whole-North')
          let front = arr.splice(index, 1)
          arr.unshift(front[0])
        }
        return this.chunkMethod(arr)
      }
    },
    EastCountries: function () {
      if (this.countries) {
        let arr = this.countries.filter(function (el) {
          return el.region === 'East'
        })
        if (!this.queryText) {
          let index = arr.map(function (o) { return o['.key'] }).indexOf('whole-East')
          let front = arr.splice(index, 1)
          arr.unshift(front[0])
        }
        return this.chunkMethod(arr)
      }
    },
    SouthCountries: function () {
      if (this.countries) {
        let arr = this.countries.filter(function (el) {
          return el.region === 'South'
        })
        if (!this.queryText) {
          let index = arr.map(function (o) { return o['.key'] }).indexOf('whole-South')
          let front = arr.splice(index, 1)
          arr.unshift(front[0])
        }
        return this.chunkMethod(arr)
      }
    },
    WestCountries: function () {
      if (this.countries) {
        let arr = this.countries.filter(function (el) {
          return el.region === 'West'
        })
        if (!this.queryText) {
          let index = arr.map(function (o) { return o['.key'] }).indexOf('whole-West')
          let front = arr.splice(index, 1)
          arr.unshift(front[0])
        }
        return this.chunkMethod(arr)
      }
    },
    showTip: function () {
      if (!Array.isArray(this.selectedItems) || !this.selectedItems.length) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    queryText: function (val) {
      let term = val.toLowerCase()
      if (term !== '') {
        this.showCen = true
        this.showNor = true
        this.showEas = true
        this.showSou = true
        this.showWes = true
      } else {
        this.showCen = false
        this.showNor = false
        this.showEas = false
        this.showSou = false
        this.showWes = false
      }
      term = term.charAt(0).toUpperCase() + term.slice(1)
      this.$bindAsArray('countries', db.ref('attributes/countries').orderByChild('name').startAt(term).endAt(term + '\uf8ff'))
    }
  },
  mounted () {
    this.$bindAsArray('countries', db.ref('attributes/countries').orderByChild('name'))
  }
}
</script>



// WEBPACK FOOTER //
// Register-Step-6.vue?25c107ca